import React, { useEffect } from "react";
import { useLoaderData } from "react-router-dom";
import ServiceForm from "../../../Components/Form/ServiceForm";
import styles from './MiraiCareer.css';


const MiraiService = () => {
  const serviceData = useLoaderData();
  const serviceContent = serviceData?.content;

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when component mounts

    // Apply Tailwind CSS classes to strong elements
    const strongElements = document.querySelectorAll('.styled-content strong');
    strongElements.forEach((el) => {
      // Check if the element has font-size: 18px
      if (window.getComputedStyle(el).fontSize === '18px') {
        // Applying Tailwind classes dynamically
        el.classList.add('textLine', 'text-3xl');
      }
    });
  }, []);

  return (
    <div>
      <div className="text-justify lg:py-20 sm:py-5 min-h-screen border-t border-blue-200">
        <div className="text-justify w-full max-w-screen-2xl mx-auto p-4">
          <h1 className="text-justify lg:text-5xl sm:text-2xl font-semibold font-jost customBlue">
            {serviceData.service}
          </h1>

          <div>
            <div
              className={`font-jost mt-10 styled-content ${styles.table}`}
              dangerouslySetInnerHTML={{ __html: serviceContent }}
            />
          </div>

          <ServiceForm />
        </div>
      </div>
    </div>
  );
};

export default MiraiService;
